import logo from "../assets/images/logo/logo.png";

export { logo };

export const companyDetails = {
  phone: "+91-7303220608",
  phone1: "+91-7292090234",
  email: "denishthangjam@gmail.com",
  email1: "orvantaai.official@gmail.com",
  address: "Changangei Mayai Leikai Road, Imphal West, Manipur, 795140",
  facebook: "https://www.facebook.com/pages/?category=your_pages&ref=bookmarks",
  twitter: "https://twitter.com/thangjam_d63217",
  instagram: "https://www.instagram.com/denish.thangjam",
  linkedin: "https://www.linkedin.com/feed/?trk=guest_homepage-basic_google-one-tap-submit",
};

export const testimonials = [
  {
    id: 1,
    img: require("../assets/images/testimonial/1.jpg"),
    quote: `The web application they built for our retail business transformed how we operate online. 
  From the initial consultation to the final launch, every detail was handled with professionalism. 
  The platform loads incredibly fast, looks stunning on all devices, and our conversion rates have 
  increased by 40% since going live. Their technical expertise and creative problem-solving made 
  all the difference.`,
    position: "Operations Manager, RetailHub Solutions",
    author: "Priya Sharma",
  },
  {
    id: 2,
    img: require("../assets/images/testimonial/2.jpg"),
    quote: `Building a mobile app seemed daunting until we partnered with this team. They translated 
  our complex requirements into an elegant, intuitive application that our field staff now rely on 
  daily. The cross-platform approach saved us significant costs while delivering native-quality 
  performance. We've already recommended them to three other companies in our network.`,
    position: "Technology Lead, FieldForce Dynamics",
    author: "Arjun Verma",
  },
  {
    id: 3,
    img: require("../assets/images/testimonial/3.jpg"),
    quote: `The AI-powered recommendation engine they developed has revolutionized our customer 
  experience. What impressed me most was their ability to understand our unique business logic 
  and translate it into intelligent algorithms. Our customer engagement metrics have improved 
  dramatically, and the system continues to learn and get better every day.`,
    position: "Head of Digital Innovation, MediaStream Plus",
    author: "Kavita Menon",
  },
  {
    id: 4,
    img: require("../assets/images/testimonial/4.jpg"),
    quote: `We needed a complete digital overhaul, and they delivered beyond expectations. The new 
  web platform integrates seamlessly with our existing systems, and the user interface is modern 
  and accessible. Their post-launch support has been exceptional, addressing every query 
  promptly. It's rare to find a team that combines technical skill with genuine care for client 
  success.`,
    position: "Director of Operations, HealthBridge Network",
    author: "Dr. Rajesh Kumar",
  },
  {
    id: 5,
    img: require("../assets/images/testimonial/5.jpg"),
    quote: `The chatbot solution powered by AI has transformed our customer service operations. 
  We're now handling 3x more inquiries with the same team size, and customer satisfaction scores 
  have actually improved. The natural language processing is remarkably accurate, and the 
  integration with our CRM was seamless. This investment has already paid for itself multiple 
  times over.`,
    position: "Customer Experience Director, TravelEase",
    author: "Neha Patel",
  },
];

// faq
export const faqs = [
  {
    id: 1,
    question: "What technologies do you specialize in?",
    answer:
      "We specialize in full-stack web development, mobile app development for iOS and Android, and artificial intelligence solutions. Our tech stack includes React, Node.js, Python, React Native, Flutter, TensorFlow, and modern cloud platforms to deliver cutting-edge digital solutions.",
  },
  {
    id: 2,
    question: "How long does a typical project take?",
    answer:
      "Project timelines vary based on complexity and scope. A basic website typically takes 4-6 weeks, while mobile apps range from 8-16 weeks. AI projects depend on data availability and model complexity. We provide detailed timelines during our initial consultation after understanding your requirements.",
  },
  {
    id: 3,
    question: "Do you provide ongoing support after launch?",
    answer:
      "Absolutely! We offer comprehensive post-launch support including bug fixes, performance monitoring, security updates, and feature enhancements. We believe in long-term partnerships and are committed to ensuring your digital products continue to perform optimally.",
  },
  {
    id: 4,
    question: "Can you work with our existing systems and infrastructure?",
    answer:
      "Yes, we excel at integrating new solutions with existing systems. Whether it's connecting to legacy databases, third-party APIs, or cloud services, we ensure seamless integration while maintaining security and performance standards.",
  },
  {
    id: 5,
    question: "What makes your AI development approach different?",
    answer:
      "We focus on practical, business-driven AI solutions rather than technology for its own sake. Our approach involves understanding your specific challenges, selecting appropriate algorithms, and delivering AI systems that provide measurable ROI and integrate smoothly with your workflows.",
  },
  {
    id: 6,
    question: "Do you develop both iOS and Android apps?",
    answer:
      "Yes, we develop native apps for both iOS and Android, as well as cross-platform solutions using React Native and Flutter. We help you choose the best approach based on your budget, timeline, target audience, and feature requirements.",
  },
  {
    id: 7,
    question: "How do you ensure project quality and security?",
    answer:
      "Quality and security are fundamental to our development process. We follow industry best practices including code reviews, automated testing, security audits, and compliance with data protection regulations. Every project undergoes rigorous quality assurance before deployment.",
  },
  {
    id: 8,
    question: "What information do you need to start a project?",
    answer:
      "To begin, we need to understand your business goals, target audience, key features you envision, any existing systems to integrate with, and your timeline and budget. We'll schedule a consultation to discuss these details and create a tailored project proposal.",
  },
];

// why work with us
export const whyworkwithus = [
  {
    id: 1,
    img: require("../assets/images/why work with us/1.webp"),
    title: "Precision Engineering",
    description:
      "We craft every solution with meticulous attention to detail, ensuring robust architecture, clean code, and seamless user experiences that stand the test of time.",
  },
  {
    id: 2,
    img: require("../assets/images/why work with us/2.webp"),
    title: "Technical Excellence",
    description:
      "Our developers are passionate experts who stay current with emerging technologies and best practices, bringing deep expertise to every challenge.",
  },
  {
    id: 3,
    img: require("../assets/images/why work with us/3.webp"),
    title: "Cutting-Edge Stack",
    description:
      "We leverage modern frameworks and cloud technologies to build fast, scalable, and maintainable solutions that give you a competitive edge.",
  },
  {
    id: 4,
    img: require("../assets/images/why work with us/4.webp"),
    title: "Partnership Mindset",
    description:
      "Your success is our success. We invest time to deeply understand your business, becoming a trusted technology partner rather than just a vendor.",
  },
  {
    id: 5,
    img: require("../assets/images/why work with us/5.webp"),
    title: "Scalable Architecture",
    description:
      "We design systems that grow with your ambitions, using flexible architectures that adapt to changing requirements and increasing user demands.",
  },
];

// core values
export const coreValues = [
  {
    title: "Innovation Through Technology",
    desc: "We embrace cutting-edge technologies and creative problem-solving to deliver solutions that push boundaries. Our commitment to continuous learning ensures we're always equipped with the latest tools and methodologies to drive your digital transformation.",
  },
  {
    title: "Quality Without Compromise",
    desc: "Excellence is woven into every line of code we write. Through rigorous testing, code reviews, and adherence to industry standards, we deliver applications that are reliable, performant, and built to last.",
  },
  {
    title: "Transparent Communication",
    desc: "We believe in open, honest dialogue throughout every project. From initial planning to final deployment, we keep you informed with clear updates, realistic timelines, and straightforward explanations of technical decisions.",
  },
  {
    title: "Client Success Focus",
    desc: "Your business objectives guide our technical decisions. We measure our success by the tangible value we create for your organization, whether that's increased efficiency, revenue growth, or enhanced user satisfaction.",
  },
  {
    title: "Agile Responsiveness",
    desc: "Markets evolve rapidly, and so do we. Our agile development approach allows us to adapt quickly to changing requirements, incorporate feedback efficiently, and deliver value in iterative cycles.",
  },
  {
    title: "Security by Design",
    desc: "Protection of your data and users is paramount. We integrate security best practices from the ground up, conducting thorough vulnerability assessments and implementing robust safeguards at every layer of your application.",
  },
  {
    title: "Collaborative Partnership",
    desc: "We work alongside your team as true partners, combining our technical expertise with your industry knowledge. Through active collaboration, we create solutions that truly understand and serve your business needs.",
  },
  {
    title: "Sustainable Development",
    desc: "We build for the long term, creating maintainable codebases and scalable architectures. Our solutions are designed to evolve gracefully, reducing technical debt and supporting your growth for years to come.",
  },
  {
    title: "Continuous Improvement",
    desc: "We never settle for good enough. Post-launch optimization, performance monitoring, and ongoing enhancements ensure your digital products continue to deliver exceptional experiences and business value over time.",
  },
];

// web development portfolio
export const webDevelopmentPortfolio = [
  {
    id: 1,
    title: "5G Homes",
    image: require("../assets/images/portfolio/web development/5ghomes.webp"),
  },
  {
    id: 2,
    title: "Autopilot",
    image: require("../assets/images/portfolio/web development/Autopilot.png"),
  },
  {
    id: 3,
    title: "Bayut",
    image: require("../assets/images/portfolio/web development/bayut.webp"),
  },
  {
    id: 4,
    title: "Cold Creekcap",
    image: require("../assets/images/portfolio/web development/cold creekcap.webp"),
  },
  {
    id: 5,
    title: "College Nutritionist",
    image: require("../assets/images/portfolio/web development/collegenutritionist.png"),
  },
  {
    id: 6,
    title: "Leadership.net",
    image: require("../assets/images/portfolio/web development/leadership.net.png"),
  },
  {
    id: 7,
    title: "Menissa Caterings",
    image: require("../assets/images/portfolio/web development/menissa caterings.webp"),
  },
  {
    id: 8,
    title: "Think Reality",
    image: require("../assets/images/portfolio/web development/think reality.webp"),
  },
];

// app development portfolio
export const appDevelopmentPortfolio = [
  {
    id: 1,
    title: "Cryptopadie",
    image: require("../assets/images/portfolio/app development/cryptopadie.png"),
  },
  {
    id: 2,
    title: "Doctor Plus",
    image: require("../assets/images/portfolio/app development/doctorplus.png"),
  },
  {
    id: 3,
    title: "Dubai Travel Guide",
    image: require("../assets/images/portfolio/app development/dubai travel guide.webp"),
  },
  {
    id: 4,
    title: "Elora Hair Palour",
    image: require("../assets/images/portfolio/app development/elora hair palour.webp"),
  },
  {
    id: 5,
    title: "Evans Francis",
    image: require("../assets/images/portfolio/app development/evans francis.webp"),
  },
  {
    id: 6,
    title: "House of Deliverance",
    image: require("../assets/images/portfolio/app development/house of deliverance.png"),
  },
  {
    id: 7,
    title: "MyBitsShop",
    image: require("../assets/images/portfolio/app development/mybitsshop.webp"),
  },
  {
    id: 8,
    title: "Namaz",
    image: require("../assets/images/portfolio/app development/namaz.webp"),
  },
  {
    id: 9,
    title: "Potea",
    image: require("../assets/images/portfolio/app development/potea.webp"),
  },
  {
    id: 10,
    title: "Rentop",
    image: require("../assets/images/portfolio/app development/rentop.png"),
  },
];
